export default "__VITE_ASSET__joI_gf46__"